import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scSentenceBreak',
})
export class SentenceBreakPipe implements PipeTransform {
  transform(text: string): string {
    return text.replace(/([.!?])\s*(?=[A-Z])/g, '$1<br>');
  }
}
